const PROCESSOS_RETURN_STORAGE_KEY = "ecp:processos:returnTo";

const VIEWS = new Set(["ativos", "rejeitados", "todos"]);

const SORT_FIELDS = new Set([
  "numeroProcesso",
  "status",
  "score",
  "valorEstimado",
  "createdAt",
  "updatedAt",
  "analisadoEm",
]);

export function isProcessosReturnPath(value) {
  return (
    typeof value === "string" &&
    (value === "/processos" || value.startsWith("/processos?"))
  );
}

export function readProcessosListQuery(searchParams) {
  const pageRaw = Number.parseInt(searchParams.get("page") || "1", 10);
  const page = Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw : 1;

  const viewParam = searchParams.get("view") || "ativos";
  const view = VIEWS.has(viewParam) ? viewParam : "ativos";

  const sortByParam = searchParams.get("sortBy") || "createdAt";
  const sortBy = SORT_FIELDS.has(sortByParam) ? sortByParam : "createdAt";
  const sortOrder = searchParams.get("sortOrder") === "asc" ? "asc" : "desc";

  return {
    page,
    view,
    sortBy,
    sortOrder,
    filters: {
      searchTerm: searchParams.get("q") || "",
      statusFilter: searchParams.get("status") || "",
      viabilityFilter: searchParams.get("viabilidade") || "",
      tribunalFilter: searchParams.get("tribunal") || "",
      esferaFilter: searchParams.get("esfera") || "",
      scoreRange: {
        min: searchParams.get("scoreMin") || "",
        max: searchParams.get("scoreMax") || "",
      },
      dateRange: {
        start: searchParams.get("dataInicio") || "",
        end: searchParams.get("dataFim") || "",
      },
    },
  };
}

export function buildProcessosListQuery({
  page,
  view,
  sortBy,
  sortOrder,
  filters,
}) {
  const params = new URLSearchParams();

  if (page && page !== 1) params.set("page", String(page));
  if (view && view !== "ativos") params.set("view", view);
  if (sortBy && sortBy !== "createdAt") params.set("sortBy", sortBy);
  if (sortOrder && sortOrder !== "desc") params.set("sortOrder", sortOrder);

  if (filters?.searchTerm) params.set("q", filters.searchTerm);
  if (filters?.statusFilter) params.set("status", filters.statusFilter);
  if (filters?.viabilityFilter) params.set("viabilidade", filters.viabilityFilter);
  if (filters?.tribunalFilter) params.set("tribunal", filters.tribunalFilter);
  if (filters?.esferaFilter) params.set("esfera", filters.esferaFilter);
  if (filters?.scoreRange?.min) params.set("scoreMin", filters.scoreRange.min);
  if (filters?.scoreRange?.max) params.set("scoreMax", filters.scoreRange.max);
  if (filters?.dateRange?.start) params.set("dataInicio", filters.dateRange.start);
  if (filters?.dateRange?.end) params.set("dataFim", filters.dateRange.end);

  return params.toString();
}

export function buildProcessosReturnTo(listState) {
  const query = buildProcessosListQuery(listState);
  return query ? `/processos?${query}` : "/processos";
}

export function rememberProcessosReturnTo(processId, returnTo) {
  try {
    sessionStorage.setItem(
      PROCESSOS_RETURN_STORAGE_KEY,
      JSON.stringify({ processId, returnTo }),
    );
  } catch {
    // sessionStorage indisponível (modo privado ou cota)
  }
}

export function resolveProcessosReturnTo(processId, returnToFromState) {
  if (isProcessosReturnPath(returnToFromState)) return returnToFromState;

  try {
    const raw = sessionStorage.getItem(PROCESSOS_RETURN_STORAGE_KEY);
    if (!raw) return "/processos";

    const parsed = JSON.parse(raw);
    if (
      String(parsed?.processId) === String(processId) &&
      isProcessosReturnPath(parsed.returnTo)
    ) {
      return parsed.returnTo;
    }
  } catch {
    // valor inválido ou storage indisponível
  }

  return "/processos";
}
